import './stepImage.css';

function StepImage({ image }) {
  return (
    <div className="stepImage-container">
         {/* <img className="step-image" src={image} alt='step imge' /> */}
         <img
          src={image}
          alt=""
          // loading="lazy"
          width="300"
          height="600"
          className='step-image'
          // style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
        />
    </div>
  );
}

export default StepImage;